export default function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}



// WEBPACK FOOTER //
// ./src/businessLogic/isObjectEmpty.js